import * as React from "react";
import { forwardRef } from "react";
const SvgPlus = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 19, height: 18, viewBox: "0 0 19 18", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", transform: "translate(.544)" }, /* @__PURE__ */ React.createElement("circle", { cx: 8.854, cy: 8.854, r: 8.854, fill: "currentColor" }), /* @__PURE__ */ React.createElement("path", { stroke: "#FFF", strokeLinecap: "square", d: "M8.854 4.354v9m4.5-4.5h-9" })));
const ForwardRef = forwardRef(SvgPlus);
export default ForwardRef;
